import React from 'react';
import styled from '@emotion/styled';
import { TabButton, TabStrip } from '@/components/CorporateShipper/blocks';

// Tighter than the page's own gap, so the tab row sits close to the tab it opens.
const TabsAndContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

// The setup tabs pad their own top for the carrier account page, where nothing else spaces them from its tab row.
// Here the tab row already does, so each tab's outer wrapper reads --tab-top-padding and starts flush.
const TabContent = styled.div`
    --tab-top-padding: 0;
`;

/**
 * The corporate account pages' tab row, and the active tab's content below it. `DrillInPage`'s `Tabs` for the
 * carrier page.
 * @param {{ tabs: import('@/components/DrillInPage').DrillInTab[], value: string, onChange: (value: string) => void }}
 *   props
 */
const CarrierTabs = ({ tabs, value, onChange }) => (
    <TabsAndContent>
        <TabStrip role="tablist">
            {tabs.map((tab) => (
                <TabButton
                    key={tab.value}
                    type="button"
                    role="tab"
                    aria-selected={tab.value === value}
                    selected={tab.value === value}
                    onClick={() => onChange(tab.value)}
                >
                    {tab.label}
                </TabButton>
            ))}
        </TabStrip>
        <TabContent>{tabs.find((tab) => tab.value === value)?.content}</TabContent>
    </TabsAndContent>
);

export default CarrierTabs;
